import MuiTableCell from '@mui/material/TableCell'
import { styled } from '@mui/material/styles'

export const TableHeadCell = styled(MuiTableCell)(({ theme }) => ({
  padding: 0,
  borderBottom: 'none',
  marginBottom: theme.spacing(1),
  fontFamily: 'Source Sans Pro SemiBold',
}))

export const TableCell = styled(MuiTableCell)({
  padding: 0,
  borderBottom: 'none',
})
